/**
 * @param {import('styled-components').AnyStyledComponent} existingStyle
 */
export default existingStyle =>
    // eslint-disable-next-line no-unused-vars
    (...args) =>
        existingStyle;
